import { Dayjs } from "dayjs"

export function humanizeDuration({
  seconds = null as number | null,
  minutes = null as number | null,
  useSeconds = false as boolean,
  oneLetter = false as boolean,
  start = null as string | Dayjs | null,
  end = null as string | Dayjs | null,
}) {
  if (useSeconds) {
    let days = 0
    let hours = 0
    let minutes = 0
    seconds = seconds || Math.round(dayjs(end).unix() - dayjs(start).unix())
    const sign = seconds < 0 ? '-' : ''

    seconds = Math.abs(seconds)
    let result = oneLetter ? `${seconds}s` : `${seconds}sec`

    if (seconds > 60) {
      minutes = Math.floor(seconds / 60)
      seconds = seconds - minutes * 60
      result = `${minutes}m`
      if (seconds > 0) result += `${seconds}s`

      if (minutes > 60) {
        hours = Math.floor(minutes / 60)
        minutes = minutes - hours * 60
        result = `${hours}h`
        if (minutes > 0) result += `${minutes}m`
        if (seconds > 0) result += `${seconds}s`
        if (hours > 24) {
          days = Math.floor(hours / 24)
          hours = hours - days * 24
          result = `${days}d`
          if (hours > 0) result += `${hours}h`
          if (minutes > 0) result += `${minutes}m`
          if (seconds > 0) result += `${seconds}s`
        }
      }
    }
    return sign + result
  } else {
    let days = 0
    let hours = 0
    minutes = minutes ?? Math.round((dayjs(end).unix() - dayjs(start).unix()) / 60)
    const sign = minutes < 0 ? '-' : ''
    minutes = Math.abs(minutes)
    let result = oneLetter ? `${minutes}m` : `${minutes}min`

    if (minutes > 60) {
      hours = Math.floor(minutes / 60)
      minutes = minutes - hours * 60
      result = `${hours}h`
      if (minutes > 0) result += `${minutes}m`
      if (hours > 24) {
        days = Math.floor(hours / 24)
        hours = hours - days * 24
        result = `${days}d`
        if (hours > 0) result += `${hours}h`
        if (minutes > 0) result += `${minutes}m`
      }
    }

    return sign + result
  }
}